export const registerOnchangeSubmitHandler = (element) => {
  element.addEventListener("change", (e) => {
    if ("form" in e.target) {
      e.target.form.requestSubmit();
    }
  });
};
